module.exports = __webpack_public_path__ + "img/winter-charging.186bd1f1.png";